import React, { useEffect } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";

function VersionDeviceCatogery({ setSelecteddevice, selectedValue, title, deviceCount, allowedDeviceCategories }) {
    const value = selectedValue ?? (allowedDeviceCategories?.[0] ?? "");

    const Handledevicecatogery = (event) => {
        setSelecteddevice(event.target.value);
      };

  return (
    <div>
      <div className="control-capabilities d-flex justify-space-between">
        <div className="hd-style-5 device_main_div">
          <div className="hd-style-5 float_left d-flex">
            <div className="black-text font-600 ">
              {title}
              <div className="gray-text-light device_no">{deviceCount}  </div>
            </div>
          </div>
        </div>
        <div className="model-srch reset w-auto date_range_position">
          <label className="field-name mb-0">Device Category</label>
          <FormControl size="small" fullWidth variant="outlined" className="custom-select select-reset radius-20">
            <Select
              name="searchBy"
              value={value}
              onChange={Handledevicecatogery}
              displayEmpty
            >
              {allowedDeviceCategories.map((device) => (
                <MenuItem key={device} value={device}>{device}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>{" "}
    </div>
  );
}

export default VersionDeviceCatogery;
